import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Button, Checklist, Field, Input, Select } from '@itds/elements';

import Api from '@carrier/utils/Api';
import { useParams } from 'react-router-dom';

const LifeDxProfile = ({ lifeDxProfile, loadCarrier }) => {
  const params = useParams();

  const [data, setData] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const profile = lifeDxProfile ? lifeDxProfile : {};

    setData({
      billing_link: profile.billing_link,
      billing_type: profile.billing_type,
      carrier_id: params.id,
      id: profile.id,
      product_permissions: profile.product_permissions
    });
  }, []);

  const handleChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleChecklistChange = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const handleSave = () => {
    setSaving(true);

    Api.saveLifeDxProfile(data.id, data).then(() => {
      setSaving(false);
      loadCarrier();
    });
  };

  return (
    <>
      <Field label='Billing Type' style={{ width: '50%' }}>
        <Select
          onChange={handleChange.bind(null, 'billing_type')}
          options={[
            { label: 'Stripe', value: 'stripe' },
            { label: 'Direct Deposit', value: 'direct_deposit' },
            { label: 'Carrier System', value: 'carrier_system' },
            { label: 'Check', value: 'check' }
          ]}
          placeholder='-- Select Type --'
          value={data.billing_type || ''}
        />
      </Field>

      <Field label='Billing Link' style={{ width: '50%' }}>
        <Input onChange={handleChange.bind(null, 'billing_link')} value={data.billing_link || ''} />
      </Field>

      <Field label='Product Permissions'>
        <Checklist
          onChange={handleChecklistChange.bind(null, 'product_permissions')}
          options={[
            { label: 'Vendor Management', value: 'vendor_management' },
            { label: 'Form Management', value: 'form_management' },
            { label: 'Life Quoting Api', value: 'life_quoting_api' },
            { label: 'LTC Quoting Api', value: 'ltc_quoting_api' },
            { label: 'Forms Api', value: 'forms_api' },
            { label: 'Embeddable Etickets', value: 'embeddable_etickets' },
            { label: 'Analytics', value: 'analytics' }
          ]}
          selected={data.product_permissions || []}
        />
      </Field>

      <Button
        disabled={saving}
        icon={saving ? 'loading mdi-spin' : null}
        inline={true}
        onClick={handleSave}
      >
        {saving ? 'Saving...' : 'Save'}
      </Button>
    </>
  );
};

LifeDxProfile.propTypes = {
  lifeDxProfile: PropTypes.object,
  loadCarrier: PropTypes.func
};

export default LifeDxProfile;
